import { PageShell } from "@/components/site/PageShell";
import { PageHeader } from "@/components/site/PageHeader";
import { BauherrArchitekt } from "@/components/landing/BauherrArchitekt";
import { FAQ } from "@/components/landing/FAQ";
import { Contact } from "@/components/landing/Contact";
import { DeveloperNote } from "@/components/landing/DeveloperNote";
import { Reveal } from "@/hooks/useReveal";
import { SeoHead } from "@/components/SeoHead";
import { PAGE_SEO, resolveSeo } from "@/data/apartmentSeo";
import { useT, useLang } from "@/i18n/LanguageProvider";

/**
 * KontaktPage – consolidated "contact / about / FAQ" sub-page.
 * Visitors who want to talk to a human, ask a question or check the
 * developer's track record land here.
 */
export default function KontaktPage() {
    const { lang } = useLang();
    const seo = resolveSeo(PAGE_SEO.kontakt, lang);
    const t = useT();

    return (
        <PageShell testId="kontakt-page">
            {(company) => (
                <>
                    <SeoHead seo={seo} />
                    <PageHeader
                        eyebrow={t({ de: "Kontakt · Team · FAQ", en: "Contact · team · FAQ" })}
                        title={t({ de: "Reden wir", en: "Let us" })}
                        titleAccent={t({ de: "über G21.", en: "talk." })}
                        subtitle={t({
                            de: "Persönlich, regional, ohne Vermittlerprovision. Wir antworten in der Regel innerhalb von 24 Stunden – montags bis samstags.",
                            en: "Personal, regional, no broker fee. We typically reply within 24 hours – Monday through Saturday.",
                        })}
                        breadcrumb={[
                            { label: t({ de: "Start", en: "Home" }), to: "/" },
                            { label: t({ de: "Kontakt", en: "Contact" }) },
                        ]}
                        bg="terracotta"
                        testId="kontakt-header"
                    />

                    <Reveal><BauherrArchitekt company={company} /></Reveal>
                    <Reveal><FAQ /></Reveal>
                    <Reveal><Contact company={company} /></Reveal>
                    <Reveal><DeveloperNote company={company} /></Reveal>
                </>
            )}
        </PageShell>
    );
}
